import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WomanIcon(props: IconProps) {
    return <Icon {...props} iconKey={"woman"}/>
}
